import { PaymentMethod } from "../models/PaymentMethod";

export enum NavigationPaths {
  Login = "/login",
  Dashboard = "/",
  VendorRequest = "/VendorRequest",
  SapVendorSearch = "/SapVendorSearch",
  VendorDetail = "/VendorDetail/:requestId?",
  RoleManagement = "/RoleManagement",
  HistoryManagement = "/HistoryManagement",
  UserHistoryManagement = "/UserHistoryManagement",
  UserManagement = "/UserManagement",
  CallOverVerification = "/CallOverVerification",
  VendorTimeOut = "/VendorTimeOut",
  VendorLogout = "/VendorLogout",
  VendorBlocking = "/VendorBlocking",
  VendorExtend = "/VendorExtend",
  AccSubCategory = "/AccSubCategory",
  Report = "/Report",
  ProcurementCategory = "/ProcurementCategory",
  VendorBlockExcemption = "/VendorBlockExcemption"
}

export enum DropdownOptions {
  //VendorDetailPaymentBankName = "Other",
  //VendorDetailNatOfbusinessPVT = "PVT Ltd",
  //VendorDetailNatOfbusinessSolP = "Sole propritery",
  //VendorDetailNatOfbusinessMASEmp = " MAS Employee",
}

export enum VendorRequestAction {
  VIEW = "VIEW",
  AMEND = "AMEND",
  EXTEND = "EXTEND",
  BLOCK = "BLOCK",
  INDIVIDUAL_PAY = "INDIVIDUAL_PAY",
}

export enum DropdownOptions_VendorDetail_BusinessNature {
  PVT = "PVT Ltd",
  SolP = "Sole propritery",
  MASEmp = " MAS Employee",
}

export enum DropdownOptions_VendorDetail_BankNumber {
  banknumberOther = "Other"
}

export enum DropdownOptions_VendorDetail_BankName {
  banknameOther = "Other"
}

export enum DropdownOptions_VendorBlocing_Reason {
  reasonOther = 7,
  blacklistedVendor = 2
}

export enum DropdownOptions_VendorBlocking_Type {
  SelectedCompanyBlock = 1,
  SelectedPoBlock = 2,
  AllCompanyBlock = 5,
  AllPoBlock = 6,
}

export enum App_Roles {
  HodApprover = 9,
  ExCo = 3,
  SBUFinance = 4,
  SBUSCHead = 15,
  GSSCCategoryLead = 16,
  Observer = 17,
  NMRPCategoryManager = 18,
  NMRPHead = 19,
  NMRPPillarLead = 20,
  NMRPProcurementDirector = 21,
  BusinessDirector = 22,
  ServicePillarLead = 23,
  ServiceProcurementDirector = 24,

}

export enum ES_Roles {
  EsRequestor = 12,
  EsTeamApprover = 13,
  EsHodApprover = 14
}

// export enum DropdownOptions_VendorBlocing_Reason_Code {
//   blacklistedVendor = "2"
// }

export enum VendorCountry {
  India = "IN",
  SriLanka = "LK",
  // Japan = "Japan",
  // Spain = "Spain",
  Kenya = "KE",
  Indonesia = "ID",
  // UK = "Uk",
  USA = "US",
  Canada = "CA"
}

export enum EuCountries {
  Austria = "AT",
  Belgium = "BE",
  Cyprus = "CY",
  CzechRepublic = "CZ",
  Germany = "DE",
  Denmark = "DK",
  Estonia = "EE",
  Spain = "ES",
  Finland = "FI",
  France = "FR",
  UnitedKingdom = "GB",
  Greece = "GR",
  Hungary = "HU",
  Ireland = "IE",
  Italy = "IT",
  Lithuania = "LT",
  Luxembourg = "LU",
  Latvia = "LV",
  Malta = "MT",
  Netherlands = "NL",
  Poland = "PL",
  Portugal = "PT",
  Romania = "RO",
  Sweden = "SE",
  Slovenia = "SI",
  Slovakia = "SK"
}

export enum UrgentFlagEnabledEnums {
  ExCoMember = 1,
  FinanceApproval = 8
}

export enum FileUploadTypes {
  BankStatement = 1,
  CompanyLetterHeadConfirmingBankAC = 2,
  CompanyLetterHeadConfirmingBR = 3,
  VATRegistationProof = 4,
  SVATRegistrationProof = 5,
  ExtraDocument_1 = 6,
  ExtraDocument_2 = 7,
  LiableForWHTAttchmnt = 8,
  BankNoObjectionLetter = 9,
  BlacklistProof = 10,
  NICCopy = 11,
  TinDoument = 12,
  PANDocument = 13,
  TrcDocument = 14,
  TaxDocument = 15,
  Tax1099Document = 16,
  SupportDoc_1 = 17,
  SupportDoc_2 = 18,
  VendorSignedDoc = 19,
  CopiesOfMandatoryCertificates = 20,
  VendorCodeOfConduct = 21,
  SpendOversightCriteria = 22,
  Other = 23,
  YarnMillEvaluation = 24,
  FabricMillEvaluation = 25,
  ElasticMillEvaluation = 26,
  CupMillEvaluation = 27,
  ThreadMillEvaluation = 28,
  GeneralMillEvaluation = 29,
  HookEyeMillEvaluation = 30,
  CartonsDividersMillEvaluation = 31,
  PolybagsMillEvaluation = 32,
  TagpinsLoopLockerTagCordMillEvaluation = 33,
  TissuesMillEvaluation = 34,
  OnboardingReasonDoc = 35
}

export enum AppApprovalPoints {
  VCExCo = 1,
  VCValidation = 2,
  VCCallBack = 3,
  VCCreate = 4,
  VCVendorFill = 5,
  VCInitial = 6,
  VCHoD = 7,
  VCFinnce01 = 8,
  VCValidation_Reject = 9,
  VCSupportFinalce = 10,
  VCSupportFinaceHoD = 11,
  VCCallBack_Reject = 12,
  VCCallBackFinace = 13,
  VCCallBackFinanceHoD = 14,
  VAVendorFill = 20,
  VAHoD = 21,
  VAExCo = 22,
  VAFinnce01 = 23,
  AmendCallover = 25,
  VAAmend = 26,
  UnblockCallover = 40,
  AmendValidation = 24,
  UnblockValidation = 37,
  AmendFinnce01 = 23,
  AmendCreate = 26,
  VEInitial = 44,
  Admin = 48,
  VEExtendVendor = 47,
  VInvVendorInitial = 49,
  VCSBU_SC_HEAD = 57,
  VASBU_SC_HEAD = 58,
  VCGSSC_CAT_LEAD = 60,
  VAGSSC_CAT_LEAD = 62,
  VcNmrp_CategoryManager = 66,
  VcNmrp_ServiceHead = 67,
  VcNmrpPillarHead = 68,
  VcProcurementDirector = 69,
  VaNmrp_CategoryManager = 70,
  VaNmrp_ServiceHead = 71,
  VaNmrpPillarHead = 72,
  VaProcurementDirector = 73,
  VCBusinessDirector = 74,
  VABusinessDirector = 75,
  VcServicePillarHead = 96,
  VaServicePillarHead = 97
}

//indicates whetre user is going to do a creation, block, extend, amend etc
export enum VendorForm1Modes {
  VendorInitialCreate = "VendorInitialCreate",
  VendorInialBlock = "VendorInialBlock",
  VendorInialExtend = "VendorInialExtend",
  VendorInitialIndividualPay = "VendorInitialIndividualPay",
  VendorInialUnBlock = "VendorInialUnBlock",
  VendorInialAmend = "VendorInialAmend",
  VendorBlockExcemption = "VendorBlockExcemption",
}

//indicates the type of the request
export enum VendorRequestViewMode {
  VendorCreate,
  VendorBlock,
  VendorExtend,
  VendorUnBlock,
  VendorAmend,
  VendorIndividualPay,
  VendorBlockExcemption,
  VendorView
}

export enum RequestTypes {
  VendorCreate = 1,//"Create Vendor",
  VendorAmend = 2, //"Amend Vendor"
  VendorBlock = 3, //"Block Vendor",
  VendorUnBlock = 4, //"Unblock Vendor",
  VendorExtend = 5, //"Extend Vendor"
  VendorIndividualPay = 6, //"Extend Vendor"
  VendorBlockExcemption = 7,//Block Excemption
}

// export enum VendorDetailViewMode {
//   VendorCreate,
//   VendorExtend
// }

export enum NatureOfBusiness {
  PVTLimited = "1",
  Partnership = "2",
  Public = "3",
  Government = "4",
  MASEmployee = "5",
  SolePropritery = "6",
  CCorporation = "7",
  SCorporation = "8",
  TrustEstate = "9",
  LimitedLiabilityCompany = "10",
}

export const acmeNOBvalues: string[] = [
  "7", "8", "9", "2", "6", "4", "5"
]

export enum RequestStatus {
  Pending = 1,
  Initial = 2, //initial
  Complete = 3,
  Rejected = 4,
  Cancelled = 5,
  InitialSubmit = 6
}


export enum RequestStatusLabel {
  Pending = "Pending",
  Initial = "Initial", //initial
  Complete = "Completed",
  Rejected = "Rejected",
  Cancelled = "Cancelled"
}

export enum ResponseObjectType {
  Success = 1,
  Warning = 2,
  Error = 3,
  SAPError = 4,
  SAPSuccess = 5
}

export enum InforDisplyaDuration {
  common = 2000,
  approvalStatus = 10000
}

export enum vendorBankModifiedStatus {
  New = 0,
  Added = 1,
  Modified = 2,
  Deleted = 3
}


export enum MasterDataConstants {
  TablerowCount = 10,
}

export const NOTIFICATIONS_REFRESH_INTERVAL: number = 100000;

export enum VendorTypeData {
  OneTimeVendor = "X008",
  GoodsSupplier = "X005",
  Employee = "X007",
  RMProductionRelated = "X001",
  AffiliatedVendorsWithinMAS = "X002",
  FixedAssetsConsumables = "X003",
  Services = "X004",
  FreightForwarder = "X006",
  Plant = "X009",
  Carriers = "X010"
}
export enum VendorCategoryData {
  RM = 1,
  NonRM = 2,
  Services = 3,
  AffiliatedVendorswithinMAS = 4,
  Employee = 5,
  Carriers = 6,

}

export enum SpendManagedByData {
  GroupProcurement = 1,
  ProcureM = 2,
  GroupProcurementAndProcureM = 3,
  SBU = 4,
  GroupProcurementAndSBU = 5
}

export enum VendorOnBoardingReasonData {
  CustomerNominated = 1,
  VerticalityImprovement = 2,
  Uniqueproductorcapability = 3,
  Price = 4,
  LeadTime = 5,
  Innovation = 6,
  Other = 7,
}

export enum CompanyCodeData {
  ACMEusa = "G100"
}

export enum InstructionKeysForSCF {
  OptInVendor = "1",
  OptOutVendor = "14"
}

export const BANKDETAILS_NOT_REQUIERD_PAYMENT_METHODS: string[] = [
  "A", "C", "D", "E", "M", "P"
];

export const SCF_ALLOWED_COMPANY_CODES: string[] = ["A000", "A050", "C000", "C050", "F050", "H000", "H050", "H150", "B000", "B050", "D000", "D050"]

export enum VendorDashboarConstants {
  TablerowCount = 10,
}

export enum FieldsLengthConstants {
  VendorName = 70,
  VendoOnboardDescript = 500,
  VendorMobileNumber = 15,
  VendorEmail = 50,
  RequestComments = 500,
  BusRegNumber = 20,
  AddressNumberStreet = 60,
  AddressPostalCode = 10,
  AddressCity = 35,
  CompanyWebSite = 40,
  VATNumber = 20,
  SVATNumber = 16,
  ExemptionNumber = 10,
  ExemptionNumberWht = 15,
  ExemDiscription = 40,
  PANNumber = 11,
  TaxNumber = 18,
  BeneficiaryAccName = 60,
  BeneficiaryAddress = 40,
  BankAccNumber = 30,
  BankName = 50,
  BankAddress = 35,
  SWIFTCode = 11,
  IBANCode = 34,
  PurposeCode = 31,
  AccountingClark = 31,
  AccountingClarkEmail = 100,
  simodis = 20,
  HoPayableLocationIndia = 40,
  HoBeneAffiliationStatusIndo = 40,
  HoPurposeofTransIndo = 40,
  HoBeneficiaryCatIndo = 40,
  BlockReasonOther = 50,
  FilledByName = 200,
  FilledByEmail = 500,
  FilledByMobile = 50,
  FilledByDesignation = 100,
  TaxContactNumber = 20,
  EmployeeEPF = 10,
  RejectReason = 150,
  PaymentContactName = 35,
  IndividualPayEstSalesTurnover = 10,
  IndividualPayNoOfInvoices = 10,
  IndividualPayBankAccWithName = 100,
  IndividualPayBankAccWithSwiftAddress = 100,
  IndividualPayGoodsDesc = 100,
  IndividualPayHsCodes = 100,
  TINNumber = 18,
  Tax1099 = 20,
  VendorNIC = 20
}

export const Max_PermittedPayee_For_Vendor: number = 3;

export enum DropdownOptions_NonRM_Services_VendorCategory {
  NonRM = 2,
  Services = 3
}
export enum DocumentType {
  VendorDocument = "Vendor",
  SupportDocument = "Support",
  TemplateDocument = "Templates"
}
export enum SupportDocumentName {
  SOPDocumentDarwinRm = "SOP_VOB Phase II Darwin-RM",
  SOPDocumentDarwinNrm = "SOP_VOB Phase II Darwin-Services & NRM",
  SOPDocumentS4Rm = "SOP_VOB Phase II HANA-RM",
  SOPDocumentS4Nrm = "SOP_VOB Phase II HANA-Services & NRM"
}
export enum DropdownOptions_TemporaryApproval_NoOfDays {
  ThirtyDays = "30",
  SixtyDays = "60",
}
export enum AutoBlockStatus {
  PlannedToInActive = 1,
  ExemptionPending = 2,
  ExemptionCompleted = 3,
  ExemptionRejected = 4
}
export enum NonRMCategoryManagedBys {
  GroupProcurement = 1,
  Legato = 2,
  GroupProcurement_Legato = 3,

}
export enum ServicesCategoryManagedBys {
  GroupProcurement = 1,
  SBU = 4,
  GroupProcurement_SBU = 5

}